import { render, staticRenderFns } from "./LinkTemplateSettings.vue?vue&type=template&id=b13cabd8&scoped=true"
import script from "./LinkTemplateSettings.vue?vue&type=script&lang=js"
export * from "./LinkTemplateSettings.vue?vue&type=script&lang=js"
import style0 from "./LinkTemplateSettings.vue?vue&type=style&index=0&id=b13cabd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13cabd8",
  null
  
)

export default component.exports